export default {
  title: 'Entwickler',
  subtitle: 'API-Schlüssel, Webhooks und Zustellungshistorie Ihrer Partner-API-Integration.',
  no_account: 'Noch kein Partner-API-Konto — kontaktieren Sie Foodamigos, um eines einzurichten.',
  no_account_manage: 'Noch kein Partner-API-Konto — erstellen Sie eines, um Schlüssel auszugeben.',
  buttons: {
    new_account: 'Neues Konto',
    edit_account: 'Konto bearbeiten',
    docs: 'API-Dokumentation',
  },
  tabs: {
    api_keys: 'API-Schlüssel',
    webhooks: 'Webhooks',
    deliveries: 'Zustellungen',
  },
  toasts: {
    load_error: 'Ihre Partner-API-Konten konnten nicht geladen werden.',
  },
};
